<template>
    <div>
        <div id="settingsNav">
            <h2>Settings</h2>
            <div class="settingsCategory" v-for="settingItem in items" :key="settingItem.title">
                <h3>{{ settingItem.title }}</h3>
                <div v-on:click="() => onItemClicked(tab.title)" :class="getClass(tab.title)" v-for="tab in settingItem.items" :key="tab.title">
                    <img :src=" tab.icon ?? '../../../assets/Icons/CTicons-05.png'" width="32" height="32" />
                    <p> {{ tab.title }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "SettingsNavigation",
    props: ['userData', 'organizationData', 'items',"onItemClicked", "currentItem"],
    data() {
        return {
            

        }
    },
    methods: {
        getClass(title) {
            if(title == this.currentItem) {
                return "settingsCategoryItem selected"
            }
            return "settingsCategoryItem"
        }
    },
    created() {
    }
};
</script>

<style scoped>
#settingsNav {
    position: relative;
    height: calc(100vh - 76px);
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 24px;
    left: -32px;
    width: 250px;
    text-align: left;
    background-color: white;
    overflow-y: auto;
}

#settingsNav::-webkit-scrollbar * {
      background:transparent;
    }

.settingsCategory {
    margin-top: 16px;
}

.settingsCategoryItem {
    border-radius: 8px;
    height: 36px;
    flex-direction: row;
    padding: 8px;
    display: flex;
    align-items: center;
}

.selected {
    background-color: #87bab7;
}

.settingsCategoryItem:hover {
    transition: .3s;
    background-color: #87bab7;
}

.settingsCategoryItem img {
    margin-right: 8px;
}
</style>